import { useEffect } from 'react';
import { initLogger } from '@trading-utils/logger';

import useConfigStore from '../../store/configStore';

import { appParameters } from '../../config/appParameters';

const configUrl = document.location.origin;

// Custom hook for fetching configuration and handling errors
export default function useConfigFetch() {
  const saveSettings = useConfigStore((state) => state.saveSettings);
  const savePackages = useConfigStore((state) => state.savePackages);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const configResponse = await fetch(`${configUrl}/config/config.json`);
        if (!configResponse.ok) throw new Error('Failed to fetch config.json');
        const environmentSettings = await configResponse.json();
        window.ENVIRONMENT_SETTINGS = environmentSettings;
        saveSettings(environmentSettings);
        initLogger(appParameters.APP_CODE, environmentSettings.DD_CLIENT, environmentSettings.ENVIRONMENT_NAME);

        const pkgsResponse = await fetch(`${configUrl}/trading-ui-pkgs.json`);
        if (!pkgsResponse.ok) throw new Error('Failed to fetch trading-ui-pkgs.json');
        const tradingUiPkgs = await pkgsResponse.json();
        savePackages(tradingUiPkgs);
        window.TRADING_UI_PACKAGES_VERSIONS = tradingUiPkgs;
      } catch (error) {
        console.error('Error fetching configurations:', error);
      }
    };

    fetchConfig();
  }, [savePackages, saveSettings]);
}
